// ---- Kundenkonto: Bestellübersicht ----
//
// Lädt die Bestellungen über /apps/konto/bestellungen. Die Anmeldung läuft
// über unser eigenes System (E-Mail + Code), nicht über Shopify — deshalb
// ist Shopifys customer-Objekt hier leer und wir holen alles per Token.
//
// Die Kundennummer kommt serverseitig aus dem geprüften Token, nie aus
// einem Feld, das der Browser mitschickt.
(function () {
  var behaelter = document.getElementById('kontoBestellungen');
  if (!behaelter) return;

  var laden = document.getElementById('kontoLaden');
  var nichtAngemeldet = document.getElementById('kontoNichtAngemeldet');
  var keine = document.getElementById('kontoKeineBestellungen');
  var fehler = document.getElementById('kontoFehler');
  var begruessung = document.getElementById('kontoBegruessungName');

  var TOKEN_SCHLUESSEL = 'nexus_kunde_token';


  // summe liefert die App bereits fertig formatiert ("1.849,00 €") —
  // direkt anzeigen. Käme je ein roher Zahlwert, wäre er in EURO
  // (NUMERIC(10,2)), nicht in Cent — also formatieren, nie durch 100
  // teilen. (Mit dem WebApp-Agenten am 27.08.2026 gegengeprüft.)
  function summeAnzeigen(wert) {
    if (wert == null || wert === '') return '';
    if (typeof wert === 'number' || (typeof wert === 'string' && isFinite(Number(wert)))) {
      return Number(wert).toLocaleString('de-DE',
        { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
    }
    return String(wert);
  }

  function token() {
    try { return localStorage.getItem(TOKEN_SCHLUESSEL) || ''; }
    catch (e) { return ''; }
  }

  function zeigen(el) {
    [laden, nichtAngemeldet, keine, fehler, behaelter].forEach(function (x) {
      if (x) x.hidden = (x !== el);
    });
  }

  function escapen(text) {
    var d = document.createElement('div');
    d.textContent = String(text == null ? '' : text);
    return d.innerHTML;
  }

  // Statusbezeichnungen der App in verständliches Deutsch übersetzen.
  // "erstattet" liefert die App nicht — bewusst weggelassen statt
  // vorzutäuschen (Rückmeldung des App-Teams). "versandbereit" kam mit
  // der ersten Testbestellung dazu (28.08.2026) — vorher unbekannt, der
  // Status wäre roh und ohne Zeitstrahl angezeigt worden.
  var STATUS_TEXT = {
    offen: 'Offen',
    bezahlt: 'Bezahlt',
    in_bearbeitung: 'In Bearbeitung',
    versandbereit: 'Versandbereit',
    unterwegs: 'Unterwegs',
    zugestellt: 'Zugestellt',
    abgeschlossen: 'Abgeschlossen',
    storniert: 'Storniert'
  };

  function datumLesbar(iso) {
    if (!iso) return '';
    // Direkt aus der Zeichenkette lesen statt über new Date() — sonst
    // verschiebt der Browser das Datum in die Zeitzone des Besuchers.
    var m = String(iso).match(/^(\d{4})-(\d{2})-(\d{2})/);
    return m ? m[3] + '.' + m[2] + '.' + m[1] : '';
  }

  // Zeitstrahl-Logik (geteilt mit der Detailseite, dort ausführlicher
  // kommentiert): aktiver Schritt pulsiert, alles davor ist gefüllt.
  // "versandbereit" und "unterwegs" liegen beide auf dem Versand-Schritt —
  // versandbereit heißt: der Schritt läuft gerade, unterwegs: das Paket
  // ist raus. Der Chip unterscheidet die beiden.
  // Zahlungsstatus einrechnen (Feld payment_status, WebApp-Agent 02.09.2026:
  // offen / bezahlt / erstattet / storniert). Der Auftragsstatus springt von
  // "offen" direkt auf "in_bearbeitung" — die Stufe "Bezahlt" kam darin nie
  // vor. Ist die Zahlung da, der Auftrag aber noch nicht weiter, zeigen wir
  // deshalb "Bezahlt": Das deckt sich mit der Rechnung, die der Kunde
  // bereits erhalten hat. Alle anderen Kombinationen bleiben beim
  // Auftragsstatus; fehlt das Feld, aendert sich nichts.
  function effektiverStatus(b) {
    var s = String(b.status || '').toLowerCase();
    if (s === 'offen' && String(b.payment_status || '').toLowerCase() === 'bezahlt') return 'bezahlt';
    return s;
  }

  var STATUS_AKTIV = { offen: 0, bezahlt: 1, in_bearbeitung: 2, versandbereit: 3, unterwegs: 3, zugestellt: 5, abgeschlossen: 5 };

  // Montage-Bestellungen sprechen die Sprache der Montage — der Kunde
  // sieht, dass gerade an SEINEM PC gearbeitet wird. "Teile beschaffen"
  // statt "Teile da": ohne Lager wird nach der Bestellung erst geordert.
  var LABELS_STANDARD = ['Bestellt', 'Bezahlt', 'In Bearbeitung', 'Unterwegs', 'Zugestellt'];
  var LABELS_MONTAGE = ['Bestellt', 'Teile beschaffen', 'Montage & Test', 'Versand', 'Zugestellt'];

  // "Montage & Test" NUR aktiv, wenn die App es über montage_phase
  // ('montage'/'test'/'fertig') ausdrücklich sagt — sonst bleibt der
  // Strahl bei "Teile beschaffen" (Befund WebApp-Agent, 02.09.2026;
  // gleiche Logik wie in bestelldetails.js). 'fertig' bleibt auf dem
  // Schritt, danach führt der Bestellstatus.
  function aktivFuer(status, montage, phase) {
    var aktiv = STATUS_AKTIV[status];
    if (aktiv === undefined) return undefined;
    if (montage && status === 'in_bearbeitung') {
      var p = String(phase || '').toLowerCase();
      return (p === 'montage' || p === 'test' || p === 'fertig') ? 2 : 1;
    }
    return aktiv;
  }

  var HAKEN = '<svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="4"><polyline points="20 6 9 17 4 12"/></svg>';

  // Jeder Schritt ist EINE Spalte (Punkt + Beschriftung untereinander) —
  // so bleiben die Texte exakt unter den Punkten, egal wie breit die
  // Karte ist. Die Verbindungslinie hängt am Schritt und läuft von der
  // Mitte des vorigen Punkts zur eigenen Mitte.
  function strahlBauen(status, montage, phase) {
    if (status === 'storniert') return '';
    var aktiv = aktivFuer(status, montage, phase);
    if (aktiv === undefined) return '';
    var labels = montage ? LABELS_MONTAGE : LABELS_STANDARD;

    var html = '<div class="nx-strahl">';
    for (var i = 0; i < 5; i++) {
      var klasse = i < aktiv ? ' ist-fertig' : (i === aktiv ? ' ist-aktiv' : '');
      html += '<div class="nx-schritt' + klasse + '">';
      if (i > 0) {
        // Gefüllt, wenn der Punkt davor erledigt ist; gestaffelte
        // Verzögerung, damit sich der Strahl von links nach rechts aufbaut.
        var voll = i <= aktiv ? ' ist-voll' : '';
        html += '<i class="nx-schritt-linie' + voll + '"><b style="animation-delay:' + (0.15 + i * 0.12).toFixed(2) + 's"></b></i>';
      }
      html += '<span class="nx-schritt-punkt">' + (i < aktiv ? HAKEN : '') + '</span>';
      html += '<span class="nx-schritt-label">' + labels[i] + '</span>';
      html += '</div>';
    }
    return html + '</div>';
  }

  function chipBauen(status) {
    var text = STATUS_TEXT[status] || status;
    // Zahlungsstatus grün (Halils Wunsch, 31.08.2026): "Bezahlt" ist eine
    // gute Nachricht und hebt sich so sichtbar von "Offen" ab.
    if (status === 'bezahlt') {
      return '<span class="nx-chip nx-chip-zugestellt">' + HAKEN + escapen(text) + '</span>';
    }
    if (status === 'unterwegs') {
      return '<span class="nx-chip nx-chip-unterwegs"><i></i>' + escapen(text) + '</span>';
    }
    if (status === 'zugestellt' || status === 'abgeschlossen') {
      return '<span class="nx-chip nx-chip-zugestellt">' + HAKEN + escapen(text) + '</span>';
    }
    if (status === 'storniert') {
      return '<span class="nx-chip nx-chip-storniert">' + escapen(text) + '</span>';
    }
    return '<span class="nx-chip nx-chip-lauf">' + escapen(text) + '</span>';
  }

  // Widerrufs-Kennzeichnung (Anfrage WebApp-Agent, 01.09.2026; Design von
  // Halil freigegeben; Status-Korrektur des App-Teams eingearbeitet:
  // es gibt offen / in_bearbeitung / abgeschlossen / null — KEIN abgelehnt).
  // - offen:           Widerruf liegt vor, Erstattung läuft automatisch
  //                    (Ware war noch nicht raus)
  // - in_bearbeitung:  Ware ist beim Kunden, Prüfung läuft, Rücksendeetikett
  //                    kommt — für den Kunden beides laufende Vorgänge
  // Datenbasis ist AUSSCHLIESSLICH widerruf_status — NIE aus
  // widerruf_moeglich ableiten, denn false kann dort auch "Frist abgelaufen"
  // heißen. Der Chip erscheint unabhängig vom Bestellstatus: Auch eine noch
  // laufende Bestellung zeigt ihren Widerruf (Halil).
  // Unbekannte Werte → kein Chip, nichts geht kaputt.
  function widerrufChipBauen(b) {
    var s = String(b.widerruf_status || '').toLowerCase();
    if (!s || s === 'null') return '';
    if (s === 'offen') {
      return '<span class="nx-chip nx-chip-widerruf-lauf"><i></i>Widerruf läuft</span>';
    }
    if (s === 'in_bearbeitung') {
      return '<span class="nx-chip nx-chip-widerruf-lauf"><i></i>Widerruf in Bearbeitung</span>';
    }
    if (s === 'abgeschlossen') {
      return '<span class="nx-chip nx-chip-widerruf-fertig">' + HAKEN + 'Widerruf abgeschlossen</span>';
    }
    return '';
  }

  // Dokument-Download (Anleitung WebApp-Agent, 31.08.2026): Die Liste
  // liefert pro Bestellung `dokumente` (immer vorhanden, ggf. leer).
  // Anzeige-Regel: Sobald die Rechnung existiert, wird NUR sie angeboten —
  // die Auftragsbestätigung wäre dann irreführend (Zahlungsaufforderung
  // für längst Bezahltes; falscher Download fürs Finanzamt). Die
  // Auftragsbestätigung erscheint nur, solange sie das einzige Dokument ist.
  function dokumentKnopf(b) {
    var docs = b.dokumente || [];
    var typ = '';
    if (docs.indexOf('rechnung') !== -1) typ = 'rechnung';
    else if (docs.indexOf('auftragsbestaetigung') !== -1) typ = 'auftragsbestaetigung';
    if (!typ) return '';
    var text = typ === 'rechnung' ? 'Rechnung herunterladen' : 'Auftragsbestätigung herunterladen';
    // Dokument-Symbol, kein Download-Pfeil — der Kunde sucht seine
    // Rechnung, keinen Download (Vorschlag des App-Teams).
    return '<span class="nx-best-dokument" role="button" tabindex="0"' +
      ' data-nummer="' + escapen(b.nummer || '') + '" data-typ="' + typ + '">' +
      '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>' +
      '<span class="nx-best-dokument-text">' + text + '</span></span>';
  }

  function karteBauen(b, index) {
    var status = effektiverStatus(b);

    var positionen = parseInt(b.positionen, 10) || 0;
    var positionText = positionen === 1 ? '1 Position' : positionen + ' Positionen';

    // Konfigurations-Kennzeichnung: kommt die Info von der App mit
    // (optionale Felder konfiguration/montage/teile), zeigen wir den
    // lila Streifen und — bei Montage — die Montage-Beschriftungen.
    // Fehlen die Felder, fällt die Karte sauber auf Standard zurück.
    var istKonfig = b.konfiguration === true || b.montage === true;
    var istMontage = b.montage === true;
    var streifen = '';
    if (istKonfig) {
      var teile = parseInt(b.teile, 10) || 0;
      var teileText = (teile > 0 ? teile + ' Bauteile' : positionText) + (istMontage ? ' + Profi-Montage' : '');
      streifen = '<div class="nx-best-konfig">' +
        '<span class="nx-best-konfig-icon"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"/></svg></span>' +
        'Deine PC-Konfiguration<small>' + escapen(teileText) + '</small>' +
      '</div>';
    }

    // Sendungsverfolgung nur anbieten, wenn beides vorliegt.
    var sendung = '';
    if (b.sendungs_url && b.sendungsnummer) {
      sendung = '<span class="nx-best-sendung" role="button" tabindex="0" data-url="' + escapen(b.sendungs_url) + '">Sendung verfolgen</span>';
    }

    var fertigKlasse = (status === 'zugestellt' || status === 'abgeschlossen') ? ' ist-abgeschlossen' : '';
    var verzoegerung = Math.min((index || 0) * 0.08, 0.56).toFixed(2);

    return '<a href="/pages/bestelldetails?nummer=' + encodeURIComponent(b.nummer || '') + '"' +
      ' class="nx-best-karte' + fertigKlasse + '" style="animation-delay:' + verzoegerung + 's">' +
      '<div class="nx-best-kopf">' +
        '<span class="nx-best-nummer">' + escapen(b.nummer) + '</span>' +
        '<span class="nx-best-datum">' + escapen(datumLesbar(b.datum)) + '</span>' +
        '<span class="nx-best-summe">' + escapen(summeAnzeigen(b.summe)) + '</span>' +
      '</div>' +
      (streifen || '<div class="nx-best-inhalt">' + positionText + '</div>') +
      strahlBauen(status, istMontage, b.montage_phase) +
      '<div class="nx-best-fuss">' +
        chipBauen(status) +
        widerrufChipBauen(b) +
        sendung +
        dokumentKnopf(b) +
        '<span class="nx-best-pfeil"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg></span>' +
      '</div>' +
    '</a>';
  }

  // Zweistufiger Download (Absicht, siehe App-Anleitung): erst BEIM KLICK
  // einen kurzlebigen Link anfordern (5 Min., einmalig — deshalb niemals
  // vorab holen oder zwischenspeichern), dann direkt dorthin navigieren.
  // Same-Tab-Navigation statt window.open: der Server antwortet mit
  // Content-Disposition: attachment, der Browser lädt herunter ohne die
  // Seite zu verlassen — und Popup-Blocker greifen nicht (die würden ein
  // window.open nach einem asynchronen fetch oft blockieren).
  var dokumentLaedt = false;
  function dokumentLaden(knopf) {
    if (dokumentLaedt) return;
    var t = token();
    if (!t) { zeigen(nichtAngemeldet); return; }
    var nummer = knopf.getAttribute('data-nummer');
    var typ = knopf.getAttribute('data-typ');
    var textEl = knopf.querySelector('.nx-best-dokument-text');
    var vorher = textEl ? textEl.textContent : '';
    dokumentLaedt = true;
    if (textEl) textEl.textContent = 'Wird geladen …';

    function zuruecksetzen(fehlerText) {
      dokumentLaedt = false;
      if (!textEl) return;
      if (fehlerText) {
        textEl.textContent = fehlerText;
        window.setTimeout(function () { textEl.textContent = vorher; }, 4000);
      } else {
        textEl.textContent = vorher;
      }
    }

    fetch('/apps/konto/dokument-link?sitzung=' + encodeURIComponent(t) +
          '&bestellnummer=' + encodeURIComponent(nummer) + '&typ=' + encodeURIComponent(typ))
      .then(function (antwort) {
        if (antwort.status === 401) {
          try { localStorage.removeItem(TOKEN_SCHLUESSEL); } catch (e) {}
          window.location.href = '/pages/anmelden?weiter=' +
            encodeURIComponent(window.location.pathname + window.location.search);
          throw new Error('anmeldung');
        }
        // 404 bewusst neutral behandeln (kann auch "gehört einem anderen
        // Konto" bedeuten — die App verrät das absichtlich nicht).
        if (!antwort.ok) throw new Error('nicht verfügbar');
        return antwort.json();
      })
      .then(function (daten) {
        if (!daten || daten.ok !== true || !daten.url) throw new Error('nicht verfügbar');
        zuruecksetzen();
        window.location.href = daten.url;
      })
      .catch(function (f) {
        if (f && f.message === 'anmeldung') return;
        zuruecksetzen('Gerade nicht verfügbar — bitte gleich noch einmal versuchen');
      });
  }

  function dokumentKlick(e) {
    var knopf = e.target.closest('.nx-best-dokument');
    if (!knopf) return;
    if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') return;
    e.preventDefault();
    e.stopPropagation();
    dokumentLaden(knopf);
  }
  behaelter.addEventListener('click', dokumentKlick);
  behaelter.addEventListener('keydown', dokumentKlick);

  function bestellungenLaden() {
    var t = token();
    if (!t) { zeigen(nichtAngemeldet); return; }

    fetch('/apps/konto/bestellungen?sitzung=' + encodeURIComponent(t))
      .then(function (antwort) {
        if (antwort.status === 401) {
          // Token abgelaufen: aufräumen und zur Anmeldung führen.
          try { localStorage.removeItem(TOKEN_SCHLUESSEL); } catch (e) {}
          try { sessionStorage.removeItem('nexus_kunde_daten'); sessionStorage.removeItem('nexus_kunde_zahlen'); } catch (e) {}
          throw new Error('nicht angemeldet');
        }
        if (!antwort.ok) throw new Error('Abfrage fehlgeschlagen');
        return antwort.json();
      })
      .then(function (daten) {
        if (!daten || daten.ok !== true) throw new Error('unerwartete Antwort');
        var liste = daten.bestellungen || [];
        // Kennzahl an die Kopfkarte melden — spart eine zweite Abfrage.
        document.dispatchEvent(new CustomEvent('nexus:kennzahl', {
          detail: { id: 'kennzahlBestellungen', wert: liste.length }
        }));
        if (!liste.length) { zeigen(keine); return; }
        behaelter.innerHTML = liste.map(function (b, i) { return karteBauen(b, i); }).join('');
        zeigen(behaelter);
      })
      .catch(function (f) {
        if (f && f.message === 'nicht angemeldet') zeigen(nichtAngemeldet);
        else zeigen(fehler);
      });
  }

  // Sendungsverfolgung öffnen, ohne dass der Klick die Bestellkarte
  // mitöffnet (die Karte selbst ist ein Link). Enter/Leertaste zählt
  // ebenfalls — der Knopf ist per role="button" fokussierbar.
  function sendungOeffnen(e) {
    var s = e.target.closest('.nx-best-sendung');
    if (!s) return;
    if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') return;
    e.preventDefault();
    e.stopPropagation();
    var url = s.getAttribute('data-url');
    if (url) window.open(url, '_blank', 'noopener');
  }
  behaelter.addEventListener('click', sendungOeffnen);
  behaelter.addEventListener('keydown', sendungOeffnen);

  // Name in der Begrüßung — kommt aus dem bereits zwischengespeicherten
  // Ergebnis von /apps/konto/ich (siehe nexus-base.js), damit hier keine
  // zweite Abfrage nötig ist.
  function begruessungSetzen() {
    if (!begruessung) return;
    try {
      var roh = sessionStorage.getItem('nexus_kunde_daten');
      if (!roh) return;
      var c = JSON.parse(roh);
      var vorname = c && c.kunde ? c.kunde.vorname : '';
      if (vorname) begruessung.textContent = ', ' + vorname;
    } catch (e) { /* ohne Namen begrüßen ist auch in Ordnung */ }
  }

  begruessungSetzen();
  bestellungenLaden();
})();
